import React, { useState } from 'react';
import SectionLabel from './SectionLabel';
import useFadeIn from '../hooks/useFadeIn';
import { projects } from '../data';
import '../styles/theme.css';

function ProjectCard({ project }) {
  return (
    <a href={project.repo} target="_blank" rel="noopener noreferrer" className="project__repo-link">
     <div className="project__card">
      {/* <div className="project__icon">{project.icon}</div> */}
      <div className="project__title">{project.title}</div>
       <p className="project__desc">{project.desc}</p>
       <div className="tags-row">
         {project.tags.map(tag => (
           <span key={tag} className="project__tag">{tag}</span>
         ))}
       </div>
     </div>
    </a>
  );
}

export default function Projects() {
  const fade = useFadeIn();

  return (
    <section id="projects" className="section">
      <SectionLabel>Projects</SectionLabel>
      <div
        ref={fade.ref}
        style={fade.style}
        className="projects-grid"
      >
        {projects.map(p => <ProjectCard key={p.id} project={p} />)}
      </div>
    </section>
  );
}
